import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["image","fileInput","imageArea","fileInputArea","errorMessage","deleteFlag"]

    connect(){
        //画像が登録済みの場合は表示
        const src = this.imageTarget.getAttribute('src')
        if(src == ''){
            this.fileInputAreaTarget.classList.remove('is-hidden')
        }else{
            this.imageAreaTarget.classList.remove('is-hidden')
        }
    }

    display(){
        const imageTarget = this.imageTarget
        const fileInput = this.fileInputTarget
        // 選択のキャンセル等で files が空のまま change が来ると readAsDataURL で例外になり、
        // 以降の処理（プレビュー・deleteFlag の解除）が丸ごと落ちる
        const file = (fileInput.files != null) ? fileInput.files[0] : null
        if(file == null){ return }
        const reader = new FileReader();
        reader.readAsDataURL(file)
        this.errorMessageTarget.innerText = ''
        this.deleteFlagTarget.value = false
        reader.addEventListener("load",(event) =>{
            imageTarget.setAttribute('src',event.target.result)
            this.imageAreaTarget.classList.remove('is-hidden')
            this.fileInputAreaTarget.classList.add('is-hidden')
        })
        this.materialize(fileInput, file)
    }

    // YAS-31 FR-1: iOS WebKit では写真ライブラリ由来の File の実体読み出しが後から失敗し、
    // multipart POST の body が空（Content-Length: 0）で送信されることがある
    // （XHR・ネイティブ submit 共通。Sentry OHDR-YQ）。
    // 選択直後（一時ファイルがまだ存在する時点）に中身をメモリへ読み込み、メモリ由来の File に
    // 差し替えることで、以後の送信がファイルハンドルに依存しないようにする。
    //
    // この partial（components/_insurance_card）は 予約保険証・プロフィール編集・家族追加・
    // 会員登録・管理画面2画面 の全てで共有されているため、ここ1か所で全画面を覆える。
    // 読み込めない場合・DataTransfer 非対応の場合は元の File のまま続行する（従来挙動）。
    // なお input.files への代入では change イベントは発火しないため、再入は起きない。
    materialize(input, file){
        if(!file.name || typeof file.arrayBuffer !== 'function' || typeof DataTransfer !== 'function'){ return }
        file.arrayBuffer().then((buf) => {
            const dt = new DataTransfer()
            dt.items.add(new File([buf], file.name, { type: file.type }))
            input.files = dt.files
        }).catch(() => {
            // 読み込めない場合は元の File のまま。送信に失敗した場合は FR-3 のエラー表示で再試行を促す
        })
    }
    remove(){
        this.imageTarget.setAttribute('src','')
        this.fileInputTarget.value = ''
        this.imageAreaTarget.classList.add('is-hidden')
        this.fileInputAreaTarget.classList.remove('is-hidden')
        this.errorMessageTarget.innerText = ''
        this.deleteFlagTarget.value = true
    }
}